/* eslint-disable no-console */
// ************************************************************ PERSONAL IMPORTS
import { modelDbData } from './model';

// ************************************************************ DEXIE IMPORTS
import Dexie from 'dexie';
import { logger } from 'src/shared/lib/logger/logger-manager'; // /!\ keep absolute import for the service worker build
import {
  IChangelog,
  IProgram,
  IRelease,
  IUserDatabase,
  IVideo,
} from '@shared/interface/model.interface';
import { IConfig } from '@shared/interface/config.interface';

// ************************************************************ DATABASES NAMES
const dbDataName = process.env.FRONTEND.databasesName.dbData;

export class ClassDbData extends Dexie {
  program: Dexie.Table<IProgram, number>;
  config: Dexie.Table<IConfig, number>;
  changelog: Dexie.Table<IChangelog, number>;
  cachedVideo: Dexie.Table<IVideo, number>;
  user: Dexie.Table<IUserDatabase, number>;

  constructor() {
    super(dbDataName);

    // Versionning
    modelDbData.forEach((currentModel) => {
      this.version(currentModel.version)
        .stores(currentModel.schema)
        .upgrade((trans) => {
          if (currentModel.upgradeFn) {
            return currentModel.upgradeFn(trans);
          } else {
            return null;
          }
        });
    });

    // The following lines are needed for it to work across typescipt using babel-preset-typescript:
    this.program = this.table('program');
    this.config = this.table('config');
    this.changelog = this.table('changelog');
    this.cachedVideo = this.table('cachedVideo');
    this.user = this.table('user');

    // Dexie events
    this.on('blocked', function () {
      logger?.log('[Dexie] Database dbData BLOQUED');
    });

    this.on('close', function () {
      logger?.log('[Dexie] Database dbData CLOSED');
    });
  }

  /**
   * db recreate (needed if model has change in a new version of the application)
   */
  deleteDbData() {
    logger?.log('start deleting dbData');
    this.delete()
      .then(() => {
        logger?.log('dbData deleted');
      })
      .catch((err) => {
        logger?.error('Could not delete database dbData - err :', err);
      });
  }

  async isEmpty() {
    return (await this.program.count()) === 0;
  }

  async isNotEmpty() {
    return (await this.program.count()) > 0;
  }
}

export const dbData = new ClassDbData();
